/**
 * Segment Repository
 */

import { apiClient } from '../../client'

import type { PaginatedResponse } from '../role.repository'

export interface Segment {
    id: number
    tenant_id: number

    en_name: string
    ar_name?: string | null
    status: number
    created_by?: number | null
    updated_by?: number | null
    created_at: Date
    updated_at: Date

    ref_code?: string

}

export interface CreateSegmentRequest {
    tenant_id: number

    en_name: string
    ar_name?: string
    status?: number
    ref_code?: string

}

export interface UpdateSegmentRequest {
    tenant_id?: number

    en_name?: string
    ar_name?: string
    status?: number
    ref_code?: string

}

class SegmentRepository {
    async getAll(page: number = 1, limit: number = 25, filters?: any): Promise<PaginatedResponse<Segment>> {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
        })

        if (filters) {
            if (filters.search) params.append('search', filters.search)
            if (filters.status) params.append('status', filters.status)

            if (filters.segment_id) params.append('segment_id', filters.segment_id)
        }

        return apiClient.get<PaginatedResponse<Segment>>(`/segments?${params.toString()}`)
    }

    async getById(id: number): Promise<Segment> {
        return apiClient.get<Segment>(`/segments/${id}`)
    }

    async create(data: CreateSegmentRequest): Promise<Segment> {
        return apiClient.post<Segment>('/segments', data)
    }

    async update(id: number, data: UpdateSegmentRequest): Promise<Segment> {
        return apiClient.put<Segment>(`/segments/${id}`, data)
    }

    async delete(id: number): Promise<{ message: string }> {
        return apiClient.delete<{ message: string }>(`/segments/${id}`)
    }

    async exportToExcel(filters?: any): Promise<Blob> {
        const params = new URLSearchParams()
        if (filters?.search) params.append('search', filters.search)
        if (filters?.status) params.append('status', filters.status)

        if (filters?.segment_id) params.append('segment_id', filters.segment_id.toString())

        const baseUrl = `/segments/export/excel`;
        const queryString = params.toString();
        const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

        return apiClient.getBlob(url, true, { showSuccessToast: true, successMessage: 'Exported Successfully' })
    }
}

export const segmentRepository = new SegmentRepository()

